import Vue from "vue";
import App from "./App.vue";
// import VueRouter from 'vue-router'
// import Router from './router.js'
import router from "./router/index.js";
import store from "./store/index.js";
import axios from "axios";
import ElementUI from "element-ui";
ElementUI.Dialog.props.closeOnClickModal.default = false;
import { Loading } from 'element-ui'

import "element-ui/lib/theme-chalk/index.css";
import 'lib-flexible/flexible.js'

import "./permission.js";

// 引入静态资源
import "@/assets/css/base.css";
import "@/assets/css/public.css";
import "@/assets/css/public.scss";
import "@/assets/css/icon.css";
// iconfont 引入的静态资源
import "@/assets/iconfont/iconfont.css";
import "@/assets/iconfont/iconfont.js";
// 引入iconfont2
import '@/assets/iconfont2/iconfont.css'
import "normalize.css/normalize.css";
import "@/style/common.css";
import common from "@/assets/js/common.js";
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// import * as echarts from "echarts";
// Vue.prototype.$echarts = echarts;

//将axios挂载在Vue扩展上
Vue.prototype.$http = axios;
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.prototype.common = common;
Vue.prototype.$loading = Loading.service

// radio报错问题
Vue.directive('removeAriaHidden', {
    bind(el, binding) {
        let ariaEls = el.querySelectorAll('.el-radio__original');
        ariaEls.forEach((item) => {
            item.removeAttribute('aria-hidden');
        });
    }
});

store.commit('setRole', localStorage.getItem('role') ? JSON.parse(localStorage.getItem('role')) : {});
store.commit('setToken', localStorage.getItem('token') ? localStorage.getItem('token') : '');

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount("#app");
